import { Resource } from "src/app/core/jsonapi/resource";
import { prop } from "@rxweb/reactive-form-validators";

export class ContractWorker extends Resource {
    public override type = 'contractWorkers';
    
    @prop()
    public contractId!: string;
    @prop()
    public workerId!: string;    
    
}